// extracted by mini-css-extract-plugin
export var orderSummary = "_qv-0";
export var showMoreLessButton = "_qv-1";